"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.name = exports["default"] = exports.availableProps = void 0;
var _react = _interopRequireDefault(require("react"));
var _selectors = require("../Theme/selectors");
var _template = _interopRequireDefault(require("./template"));
var _excluded = ["color"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var Whistle = function Whistle(_ref) {
  var color = _ref.color,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_template["default"], _extends({}, otherProps, {
    renderPaths: function renderPaths(uiTheme) {
      var style = {};
      if (color) {
        style.fill = (0, _selectors.getColor)(uiTheme, color);
      }
      return /*#__PURE__*/_react["default"].createElement("path", {
        style: style,
        d: "M32.3076923,8 C34.3468975,8 36,9.6117749 36,11.6 C36,13.2209055 34.9012875,14.5916084 33.3903821,15.0427521 C34.0111492,16.3006194 34.3589744,17.7107057 34.3589744,19.2 C34.3589744,24.5019336 29.9507011,28.8 24.5128205,28.8 C22.207975,28.8 20.0880972,28.0278575 18.4104527,26.7344066 L9.74358974,32 L4,25.6 L16.9433077,13.0602753 C18.7494219,10.9458233 21.4699244,9.6 24.5128205,9.6 C26.0403018,9.6 27.4865442,9.93912951 28.7766645,10.5443775 C29.239376,9.07124471 30.6452251,8 32.3076923,8 Z M17.9590262,15.3129942 L16.2184556,17.0100505 L19.9896918,20.6870058 L21.7302623,18.9899495 L17.9590262,15.3129942 Z M32.3076923,10.4 C31.6279572,10.4 31.0769231,10.9372583 31.0769231,11.6 C31.0769231,11.8110916 31.1328256,12.0094528 31.2309838,12.181778 C31.3964203,12.3323866 31.5565266,12.4884903 31.7109969,12.6497908 C31.8877407,12.745495 32.0911881,12.8 32.3076923,12.8 C32.9874274,12.8 33.5384615,12.2627417 33.5384615,11.6 C33.5384615,10.9372583 32.9874274,10.4 32.3076923,10.4 Z"
      });
    }
  }));
};
Whistle.defaultProps = {
  color: null
};
var _default = exports["default"] = Whistle;
var name = exports.name = 'Whistle';
var availableProps = exports.availableProps = ['color'];